import { post, get } from "../axios/index.js"
// console.log("🚀 ~ post:", post, get)
export const systemConfigGlobalV2 = async (parmas) => {
  const res = await get('/system/config/global/v2', parmas)
  return res || {}
}
// 待办提醒消息列表
export const messageList = async (parmas) => {
  const res = await post('/message/list', parmas)
  return res || {}
}
// 系统通知消息列表
export const glyMessageRecordList = async (parmas) => {
  const res = await post('/glyMessageRecord/list', parmas)
  return res || {}
}
// 消息全部已读
export const glyMessageRecordAKeyRead = async (parmas) => {
  const res = await post('/glyMessageRecord/aKeyRead', parmas)
  return res || {}
}
// 时区列表
export const systemZone = async (parmas) => {
  const res = await post('/system/zone', parmas)
  return res || {}
}
// 消息实时
export const glyMessageRecordRealtime = async (parmas) => {
  const res = await post('/glyMessageRecord/realtime', parmas)
  return res || {}
}
// 消息实时 提交回执
export const glyMessageRecordUpdate = async (parmas) => {
  const res = await post('/glyMessageRecord/update', parmas)
  return res || {}
}
// 常量接口
export const systemGetDoc = async (parmas) => {
  const res = await post('/system/getDoc', parmas)
  return res || {}
}
//日志查询筛选项获取下拉选项
export const systemLogType = async (parmas) => {
  const res = await post('/system/log/type', parmas)
  return res || {}
}
//日志查询
export const systemLogOtslist = async (parmas) => {
  const res = await post('/system/log/otslist', parmas)
  return res || {}
}
//报警日志查询
export const systemLogOtsAlarmConfigOperLogList = async (parmas) => {
  const res = await post('/system/log/alarmConfigOperLogList', parmas)
  return res || {}
}

//获取各种货币单位集合
export const systemCityCurrency = async (parmas) => {
  const res = await post('/system/cityCurrency', parmas)
  return res || {}
}

//国外,获取时区,货币单位
export const systemFindCountry = async (parmas) => {
  const res = await post('/system/findCountry', parmas)
  return res || {}
}
